import { useCallback } from 'react';
import { useStore } from '@tmsw/powerups.store';

export const usePauseConditions = () => {
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);
  return useCallback(
    () => showSettingsPanel || isPauseEnabled || !inPortrait,
    [showSettingsPanel, isPauseEnabled, inPortrait]
  );
};
